module.exports = vendor_dbe7b4cbc10cee3aafde;